import React, { useMemo } from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Label } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useToggleWorkflowStatus from "./hooks/useToggleWorkflowStatus";
const StatusLabel = styled(Label)`
  cursor: ${({ $isUpdating }) => $isUpdating ? "wait" : "pointer"};
  opacity: ${({ $isUpdating }) => $isUpdating ? 0.7 : 1};
`;
const InnerContainer = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xxs};
`;
const Spacer = styled.span`
  border-left: 1px solid currentColor;
  height: 0.8em;
`;
const STATUS_LABEL = {
  running: "Running",
  paused: "Paused"
};
const WorkflowStatus = ({ workflow, onSuccess }) => {
  const sendTelemetry = useSendTelemetry();
  const { mutateAsync: toggleStatus, isPending } = useToggleWorkflowStatus();
  const isRunning = !workflow.disabled;
  const hasConfig = (workflow == null ? void 0 : workflow.model) && (workflow == null ? void 0 : workflow.provider);
  const title = useMemo(() => {
    if (!hasConfig) return "Setup provider configuration to be able run the scheduled workflow.";
    if (isRunning) return "Stop workflow";
    return "Start workflow";
  }, [hasConfig, isRunning]);
  const onClick = (e) => {
    if (!isRunning && !hasConfig) return null;
    e.stopPropagation();
    if (!isPending) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.WORKFLOW_STATUS_TOGGLED, {
        app_section: "aiagent-workflows",
        event_details: { workflow_type: workflow.id, next_status: isRunning ? "paused" : "running" }
      });
      toggleStatus(workflow).then(onSuccess);
    }
  };
  return /* @__PURE__ */ React.createElement(
    StatusLabel,
    {
      bsStyle: isRunning ? "success" : "warning",
      onClick,
      title: isPending ? "Updating workflow status" : title,
      "aria-label": isPending ? "Updating workflow status" : title,
      $isUpdating: isPending
    },
    /* @__PURE__ */ React.createElement(InnerContainer, null, isRunning ? STATUS_LABEL.running : STATUS_LABEL.paused, (hasConfig || isRunning) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Spacer, null), /* @__PURE__ */ React.createElement(Icon, { name: isRunning ? "pause" : "play_arrow", size: "xs" })))
  );
};
export default WorkflowStatus;
